import { render, staticRenderFns } from "./RastreabilidadeRaizen.vue?vue&type=template&id=5f56e961&lang=pug"
import script from "./RastreabilidadeRaizen.vue?vue&type=script&lang=js"
export * from "./RastreabilidadeRaizen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports